import CaretArrowSvg from "@/assets/svg/CaretArrowSvg";
import theme from "@/theme";
import { Box, Typography } from "@mui/material";

interface AccountInfoItemProps {
  label: string;
  value: string | undefined;
  onClick: () => void;
}

const AccountInfoItem = ({ label, value, onClick }: AccountInfoItemProps) => (
  <Box
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
    alignItems="center"
    padding="12px 16px"
    onClick={onClick}
    sx={{
      cursor: "pointer",
    }}
  >
    <Box display="flex" flexDirection="column" gap="2px">
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "15px",
          lineHeight: "24px",
          letterSpacing: 0,
          fontFamily: "Inter",
          color: theme.palette.custom.blueGray900,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "13px",
          lineHeight: "20px",
          letterSpacing: 0,
          fontFamily: "Inter",
          color: theme.palette.custom.blueGray600,
        }}
      >
        {value}
      </Typography>
    </Box>
    <CaretArrowSvg height={24} width={24} />
  </Box>
);

export default AccountInfoItem;
